
import React from "react";

import "./image.scss";

function ImagePart(props)
{
    return (
        <div className="flip-card tabindex" tabIndex="0">
            <div className={`flip-card-inner${(props.hover === props.i || props.clicked === props.i) ? ' hover' : ''}`} onClick={() => props.setClicked(props.i)}>
                <div className="flip-card-front">
                    <div className={`si si${props.i}`} style={{backgroundImage:`url(${props.student.image})`}}></div>
                </div>
                <div className="flip-card-back">
                    <div className={`si si${props.i}`} style={{backgroundImage:`url(${props.student.image})`}}></div>
                    <div className={`bg bg${props.i}`}><div className="text">{props.student.image_description[props.i]}</div></div>
                </div>
            </div>
        </div>
    )
}
export const Image = (props) => {

    return (
        <div className="image">
            <section className="wrapper" onMouseOver={() => props.stopRnd()}>
                <div className="folder">
                    <ImagePart i={2} {...props} />
                    <ImagePart i={5} {...props} />
                    <ImagePart i={8} {...props} />
                </div>
                <div className="folder">
                    <ImagePart i={1} {...props} />
                    <ImagePart i={4} {...props} />
                    <ImagePart i={7} {...props} />
                </div>
                <div className="folder">
                    <ImagePart i={0} {...props} />
                    <ImagePart i={3} {...props} />
                    <ImagePart i={6} {...props} />
                </div>
            </section>
        </div>
    );
};

export default Image;
